// Perche' un "Recuperabile" non va in automatico: gli stessi controlli del ciclo
// (`services/auto_apply_gate.py`). Condiviso da Prodotti e Panoramica.
export const MOTIVI_BLOCCO: Record<string, string> = {
  supplier_off: "fornitore spento",
  marketplace_off: "marketplace spento",
  locked: "prezzo bloccato a mano",
  above_threshold: "oltre soglia",
  no_cost: "manca costo",
  no_floor: "manca floor",
  no_offer: "offerta non in vetrina",
  not_measured: "prezzo non misurato",
  no_publication: "senza publication",
  not_mapped: "listing non collegato",
};

export interface MotivoBlocco {
  motivo: string;
  etichetta: string;
  n: number;
}

export function motiviOrdinati(motivi: Record<string, number>): MotivoBlocco[] {
  return Object.entries(motivi)
    .filter(([, n]) => n > 0)
    .sort((a, b) => b[1] - a[1])
    .map(([motivo, n]) => ({ motivo, etichetta: MOTIVI_BLOCCO[motivo] ?? motivo, n }));
}

export function riepilogoMotivi(motivi: Record<string, number>): string {
  const parti = motiviOrdinati(motivi).map((m) => `${m.etichetta}: ${m.n}`);
  return parti.length ? `Bloccati — ${parti.join(" · ")}` : "Tutti azionabili in automatico";
}
